import { Component, Input } from '@angular/core';
import { IconDefinition, faCompactDisc, faDrum, faGuitar, faHeadphones, faMicrophone, faMusic } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-saving-overlay',
  template: ` <div class="o-loader-overlay">
    <div class="o-card">
      <div class="o-loader-strip">
        <div class="o-loader-track">
          @for (instrument of instruments; track $index) {
            <fa-icon [icon]="instrument"></fa-icon>
          }
          @for (instrument of instruments; track $index) {
            <fa-icon [icon]="instrument"></fa-icon>
          }
        </div>
      </div>
      <div class="o-loader-title">{{ title }}</div>
      <div class="o-loader-subtitle">{{ subtitle }}</div>
    </div>
  </div>`
})
export class SavingOverlayComponent {
  @Input() title = 'Saving...';
  @Input() subtitle = 'Please wait while we save your changes.';

  readonly instruments: Array<IconDefinition> = [faMusic, faGuitar, faDrum, faHeadphones, faMicrophone, faCompactDisc];
}
